export default "__VITE_ASSET__D9sNW3Ne__"